import { PayloadAction, createSlice } from '@reduxjs/toolkit'
import { FlowSteps } from './flow-types'
import { DONATION_GRID_STEP_NAME, makeDonationGridStep } from './utils/steps/donation-grid'

const INITIAL_STATE = {
  stepsMap: {
    [DONATION_GRID_STEP_NAME]: makeDonationGridStep(),
  } as FlowSteps,
  currentStepName: DONATION_GRID_STEP_NAME,
}

const flowSlice = createSlice({
  name: 'flow',
  initialState: INITIAL_STATE,
  reducers: {
    // Go to step by given name
    goToStep: (state, action: PayloadAction<string>) => {
      const step = state.stepsMap[action.payload]

      if (step) {
        state.currentStepName = action.payload

        step.numVisits += 1
      }
    },

    /**
     * Enable a flow step by name.
     *
     * Useful in middlewares to enable/disable steps based on state
     * changes in other Redux store slices.
     */
    enableStep: (state, action: PayloadAction<string>) => {
      const step = state.stepsMap[action.payload]

      if (step) {
        step.enabled = true
      }
    },

    /**
     * Disable a flow step by name.
     *
     * Useful in middlewares to enable/disable steps based on state
     * changes in other Redux store slices
     */
    disableStep: (state, action: PayloadAction<string>) => {
      const step = state.stepsMap[action.payload]

      if (step) {
        step.enabled = false
      }
    },

    /**
     * Disable all flow steps before step by name.
     *
     * Useful in middlewares to enable/disable all steps before a certain step
     */
    disableStepsBefore: (state, action: PayloadAction<string>) => {
      const step = state.stepsMap[action.payload]

      Object.values(state.stepsMap).forEach((curStep) => {
        if (curStep.index < step.index) {
          state.stepsMap[curStep.name].enabled = false
        }
      })
    },
  },
})

export default flowSlice
